import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { switchMap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { KkmsService } from '../../../core/services/kkms.service';
import { PageHeaderDropdownItem } from '../../../shared/page-header/page-header.model';
import { LanguageService } from '../../../core/services/language.service';
import { RetailPlaceDetailsState } from './retail-place-details.state';
import { IRetailPlace } from '../../../core/modules/retail-places/retail-paces.types';
import { RetailPlacesApiService } from '../../../core/modules/retail-places/retail-places-api.service';

@UntilDestroy()
@Component({
  selector: 'tax-retail-place-details',
  templateUrl: './retail-place-details.component.html',
  styleUrls: ['./retail-place-details.component.sass'],
})

export class RetailPlaceDetailsComponent implements OnInit {
  retailPlace?: IRetailPlace;
  kkmId: string = '';
  readonly dropdownItems: PageHeaderDropdownItem[] = [{
    action: () => this.router.navigate(['settings'], {
      relativeTo: this.activatedRoute,
    }),
    icon: 'edit',
    title: 'kkm.settings',
  }];

  private isScrollPositionSave = false;
  private retailPlaceId = Number(this.activatedRoute.snapshot.paramMap.get('id'));

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private retailPlaceApiService: RetailPlacesApiService,
    private kkmsService: KkmsService,
    private languageService: LanguageService,
    private viewportScroller: ViewportScroller,
    private retailPlaceDetailsState: RetailPlaceDetailsState,
  ) {}

  @HostListener('window:scroll')
  onScroll(): void {
    /** Проблемы
     * 1. Если мы находимся не на этой странице и позиция скрола !== 0, и
     * возвращаемся на эту страницу, то происходит браузерное событие scroll.
     * В результате сохранённая позиция перетирается.
     * 2. Если при использовании метода Location.back() мы возвращаемся
     * на эту страницу, то происходит событие scroll.
     * В результате сохранённая позиция перетирается.
     *
     * Решение
     * Надо вызывать сохранение позиции скрола после того, как выполнится
     * событие скрола из случаев выше.
     * */
    if (this.isScrollPositionSave) {
      this.retailPlaceDetailsState.setRetailPlaceScrollPosition(window.scrollY);
    }
  }

  ngOnInit(): void {
    this.languageService.languageChanges
      .pipe(
        switchMap(() => this.retailPlaceApiService.fetchRetailPlace(this.retailPlaceId)),
        untilDestroyed(this),
      )
      .subscribe({
        next: (response) => {
          this.retailPlace = {
            ...response,
            kkms: this.kkmsService.sortKkms(response.kkms),
          };
        },
      });
  }

  scrollToPosition(): void {
    this.isScrollPositionSave = true;
    this.viewportScroller.scrollToPosition(
      [0, this.retailPlaceDetailsState.getRetailPlaceScrollPosition(this.retailPlaceId)],
    );
    this.retailPlaceDetailsState.setRetailPlaceId(this.retailPlaceId);
  }
}
